"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ContactFormImpl_1 = require("./impl/ContactFormImpl");
class ContactForm extends ContactFormImpl_1.default {
    onEnquirySubmit(event) {
        super.onEnquirySubmit(event);
        alert('Enquiry has been sent');
    }
    render() {
        return (React.createElement("form", { onSubmit: this.onEnquirySubmit },
            React.createElement("div", { className: "controls" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("input", { id: "form_name", type: "text", name: "name", className: "form-control", placeholder: "Full Name", required: true, "data-error": "Name is required.", onChange: this.nameChange, value: this.state.name }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-user" })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("input", { id: "form_email", type: "email", name: "email", className: "form-control", placeholder: "Email Address", required: true, "data-error": "Valid email is required.", onChange: this.emailChange, value: this.state.email }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-envelope" }),
                    React.createElement("div", { className: "help-block with-errors" })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("textarea", { id: "form_message", name: "message", className: "form-control", placeholder: "Message for me", rows: 4, required: true, "data-error": "Please, leave me a message.", onChange: this.commentChange, value: this.state.message }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-comment" }),
                    React.createElement("div", { className: "help-block with-errors" })),
                React.createElement("input", { type: "submit", className: "button btn-send disabled", value: "Send message" }))));
    }
    ;
}
exports.default = ContactForm;
